import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  IonList,
  IonItem,
  IonBadge,
  IonLabel,
  IonGrid,
  IonSegment,
  IonSegmentButton
} from '@ionic/react';
import PaginationBtns from 'src/components/PaginationBtns';
import WithRecords from 'src/components/WithRecords';
import { formatDate, startOf, endOf } from 'src/lib/time';
import noData from 'src/images/no-data.svg';
import { NOT_STARTED, IN_PROGRESS, COMPLETED } from 'src/constants';

class Jobs extends React.Component {
  ranges = () => ({
    today: { $gte: startOf('day'), $lte: endOf('day') },
    week: { $gte: startOf('week'), $lte: endOf('week') }
  });
  state = {
    range: 'today'
  };
  setRange = async (range) => {
    this.setState({ range });
    if (range === 'all') {
      const { scheduled_time, ...rest } = this.props.query;
      await this.props.setQuery({ ...rest });
    } else {
      await this.props.setQuery({
        ...this.props.query,
        scheduled_time: this.ranges()[range]
      });
    }
    this.props.search();
  };
  render() {
    const { range } = this.state;
    const { resources: jobs } = this.props;
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="end">
              <IonMenuButton menu="mainMenu" autoHide={false} />
            </IonButtons>
            <IonTitle>Murphy</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid fixed>
            <div className="ion-padding">
              <IonSegment
                value={range}
                onIonChange={({ detail }) => this.setRange(detail.value)}
              >
                <IonSegmentButton value="today">
                  <IonLabel>Today</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="week">
                  <IonLabel>This Week</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="all">
                  <IonLabel>All</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </div>
            {jobs.length > 0 ? (
              <React.Fragment>
                <JobList jobs={jobs} />
                <PaginationBtns {...this.props} />
              </React.Fragment>
            ) : (
              <NoData />
            )}
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  }
}

const NoData = () => (
  <div className="ion-padding ion-text-center">
    <img src={noData} className="ion-margin-bottom" alt="No Jobs" />
    <h3>No Jobs</h3>
  </div>
);

const statusColors = {
  [NOT_STARTED]: 'medium',
  [IN_PROGRESS]: 'primary',
  [COMPLETED]: 'success'
};

const JobList = ({ jobs, ...rest }) => {
  return (
    <React.Fragment>
      <IonList>
        {jobs.map((job) => (
          <IonItem key={job._id} routerLink={`/jobs/${job._id}`}>
            <IonLabel>
              <h2>{job.customer.full_name}</h2>
              <h3>{formatDate(job.scheduled_time, 'iii, MMM d, h:mm a')}</h3>
              <p>{job.job_template.title}</p>
            </IonLabel>
            <IonBadge color={statusColors[job.status]} slot="end">
              {job.status}
            </IonBadge>
          </IonItem>
        ))}
      </IonList>
    </React.Fragment>
  );
};

export default (routerProps) => {
  return (
    <WithRecords
      useLifecycle={true}
      service="api/jobs"
      defaultQuery={{
        $sort: { scheduled_time: -1 },
        scheduled_time: { $gte: startOf('day'), $lte: endOf('day') }
      }}
      render={(withRecordsProps) => {
        return <Jobs {...routerProps} {...withRecordsProps} />;
      }}
    />
  );
};
